/******************************************************************************************
 *	Extend Customer Renewal Window
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.extendCustomerRenewalWindow', []).controller(
    'ExtendCustomerRenewalWindowController',
    /* @ngInject */
    function(
      $log,
      $scope,
      $state,
      $stateParams,
      feature,
      Settings,
      Customer,
      BreadcrumbsMenu,
      CustomerSegments,
      CurtainNotifications,
      SelectedCustomer
    ) {
      //Controls visibility of content area
      $scope.noData = true;

      //Expose max number of days the renewal window can be extended by, at one time
      $scope.maxRenewalDays = Settings.MAX_RENEWAL_EXTENSION_DAYS;

      var customerID = $stateParams.customerID;

      //Navigation
      $scope.goToCustomerList = function() {
        $state.go('licenseAdmin.impersonatedReseller.customers.segments', {
          segment: CustomerSegments.getAllCustomersSegment()
        });
      };
      $scope.goBack = function() {
        $state.go('licenseAdmin.impersonatedReseller.customerDetails', {customerID: customerID});
      };

      //Create $scope.renewalInfo from customer data
      var extractRenewalInformation = function(customer) {
        var renewalWindowData = customer.renewalWindowInfo;

        //If customer's outside the renewal window, just send the user back to the customer details page
        if (!renewalWindowData) {
          $scope.goBack();
        } else {
          $scope.noData = false; //We have data
          $scope.loadingData = false; //Loading spinner off

          $scope.renewalInfo = {
            lastAnniversaryDate: customer.anniversaryDate,
            currentAnniversaryDate: customer.previousAnniversaryDate || customer.anniversaryDate,
            daysInto: parseInt(renewalWindowData.daysIntoWindow, 10) || 0,
            windowStartDate: renewalWindowData.startDate,
            windowEndDate: renewalWindowData.endDate,
            totalDuration: parseInt(renewalWindowData.totalWindowDuration, 10) || 0,
            daysLeft: parseInt(renewalWindowData.daysLeftInWindow, 10) || 0
          };

          //Init newTotalDuration
          $scope.newTotalDuration = $scope.renewalInfo.totalDuration;
          $scope.newWindowEndDate = $scope.renewalInfo.windowEndDate;
        }
      };

      //Get Customer Details
      var getCustomer = function() {
        //Loading spinner on
        $scope.loadingData = true;

        Customer.getDetails(customerID)
          .then(function(responseData) {
            extractRenewalInformation(responseData);
          })
          .catch(function(response) {
            $log.warn(response.data, response.status);

            if (response.status !== 0) {
              //status is 0 when call is aborted
              CurtainNotifications.show(
                CurtainNotifications.NOTICE,
                'customerDetails.notifications.invalidCustomer'
              );
              $scope.goToCustomerList();
            }
          });
      };

      if (SelectedCustomer.get() && SelectedCustomer.get().id === customerID) {
        extractRenewalInformation(SelectedCustomer.get());
        $scope.noData = false;
      } else {
        getCustomer();
      }

      //Calculate extended window end date
      $scope.extendByChanged = function() {
        var extendBy = parseInt($scope.extendBy, 10) || 0;

        //Update new total window duration
        $scope.newTotalDuration = $scope.renewalInfo.totalDuration + extendBy;

        //Update new window end date
        //Won't be in PT but it does not matter here, date math in this case is relative to the first date which is in PT
        var date = new Date($scope.renewalInfo.windowEndDate);
        $scope.newWindowEndDate = new Date(date.setDate(date.getDate() + extendBy)).toISOString();
      };

      //Submit
      var resetSubmit = function() {
        $scope.submitAttempted = false;
        $scope.submitted = false;
      };

      $scope.submit = function() {
        $scope.submitAttempted = true;
        var extendBy = parseInt($scope.extendBy, 10);

        if (extendBy > 0) {
          $scope.submitted = true;

          var extensionData = {
            endDate: $scope.newWindowEndDate,
            startDate: $scope.renewalInfo.windowStartDate
          };

          Customer.extendRenewalWindow(customerID, extensionData)
            .then(function() {
              //Return to the customer details page
              $scope.goBack();

              CurtainNotifications.show(
                CurtainNotifications.INFO,
                'extendRenewalWindow.notifications.newSubmitSuccess'
              );
            })
            .catch(function(response) {
              $log.error('Failed to extend renewal window', response.data);

              if (response.data && response.data.errorMessage) {
                if (response.data.errorMessage === 'TOO_LARGE_TOTAL_DURATION_RENEWAL_INFO') {
                  CurtainNotifications.show(
                    CurtainNotifications.ERROR,
                    'extendRenewalWindow.notifications.extendLimitReached'
                  );
                } else if (response.data.errorMessage === 'CUSTOMER_NOT_IN_RENEWAL_WINDOW') {
                  CurtainNotifications.show(
                    CurtainNotifications.ERROR,
                    'extendRenewalWindow.notifications.outsideRenewalWindow'
                  );

                  //Return to the customer details page
                  $scope.goBack();
                  return;
                } else {
                  CurtainNotifications.show(
                    CurtainNotifications.ERROR,
                    'generic.notifications.error'
                  );
                }
              } else {
                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'generic.notifications.error'
                );
              }

              //Only resetting in case of error
              //In case of success, customer details view is loaded
              resetSubmit();
            });
        }
      };

      /*=== Breadcrumbs ===*/
      //Add customer ID for Customer Details link
      BreadcrumbsMenu.updateStateParams('licenseAdmin.impersonatedReseller.customerDetails', {
        customerID: customerID
      });
    }
  );
})();
